import { Avatar, CircularProgress, Divider, Grid } from "@mui/material";
import { Modal } from "../../components";
import formatName from "../../helpers/formatName";
import ButtonComponent from "../../components/ButtonComponent";

// FIX: se o nome tiver só uma palavra, name.split(" ")[1] é undefined e crasha
function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    color += `00${((hash >> (i * 8)) & 0xff).toString(16)}`.slice(-2);
  }
  return color;
}

function stringAvatar(name = "") {
  const parts = name.trim().split(" ").filter(Boolean);
  const initials = parts.length >= 2
    ? `${parts[0][0]}${parts[1][0]}`
    : parts[0]?.[0] ?? "?";
  return { sx: { bgcolor: stringToColor(name) }, children: initials.toUpperCase() };
}

const btnBase = {
  border: "none", borderRadius: 8, padding: "10px 20px",
  fontSize: 13, fontWeight: 600, cursor: "pointer",
  fontFamily: "Poppins, sans-serif",
};

function ModalEncaminhamentoChamada({
  setModalAtendente, modalAtendente,
  atendentesOnline, atendenteSelected,
  SelecionarAtendente, atendenteSelectedData,
  TransferirChamada, EscolherOutro, loading,
}) {
  return (
    <Modal open={modalAtendente} width="100%" style={{ borderRadius: 14 }}>
      {!atendenteSelected ? (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <h4 style={{ margin: 0, fontFamily: "Poppins, sans-serif", fontSize: 15 }}>
              Selecione um atendente
            </h4>
            <button
              onClick={() => setModalAtendente(false)}
              style={{ ...btnBase, background: "#f3f4f6", color: "#374151", padding: "7px 14px" }}
            >
              Fechar
            </button>
          </div>
          <Divider />

          {atendentesOnline?.length === 0 ? (
            <p style={{ textAlign: "center", color: "#9ca3af", padding: "40px 0", fontFamily: "Poppins, sans-serif", fontSize: 13 }}>
              Nenhum atendente disponível no momento.
            </p>
          ) : (
            <Grid container spacing={1} style={{ padding: "20px 0" }}>
              {atendentesOnline.map((at, index) => (
                <Grid item xs={6} sm={4} md={3} key={at.usuario_id ?? index}>
                  <button
                    onClick={() => SelecionarAtendente(at)}
                    style={{
                      width: "100%", background: "#fff",
                      border: "1px solid #e5e7eb", borderRadius: 10,
                      padding: "12px", cursor: "pointer", textAlign: "left",
                      fontFamily: "Poppins, sans-serif", transition: "all 0.15s",
                    }}
                    onMouseEnter={e => { e.currentTarget.style.background = "#f0f9ff"; e.currentTarget.style.borderColor = "#0ea5e9"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#e5e7eb"; }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <Avatar {...stringAvatar(at.nome)} style={{ width: 36, height: 36, fontSize: 14 }} />
                      <span style={{ fontSize: 13, fontWeight: 500, color: "#111827" }}>
                        {formatName(at.nome)}
                      </span>
                    </div>
                  </button>
                </Grid>
              ))}
            </Grid>
          )}
        </>
      ) : (
        <>
          <h4 style={{ margin: "0 0 12px", fontFamily: "Poppins, sans-serif", fontSize: 15 }}>
            Confirmar encaminhamento
          </h4>
          <Divider />

          <div style={{ padding: "24px 0", display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 14,
              border: "1px solid #e5e7eb", borderRadius: 12, padding: "16px 24px",
            }}>
              <Avatar {...stringAvatar(atendenteSelectedData.nome ?? "")} />
              <div>
                <div style={{ fontWeight: 600, fontSize: 14, fontFamily: "Poppins, sans-serif" }}>
                  {formatName(atendenteSelectedData.nome)}
                </div>
                <div style={{ fontSize: 12, color: "#6b7280", fontFamily: "Poppins, sans-serif" }}>
                  A chamada será transferida para este atendente
                </div>
              </div>
            </div>

            <div style={{ display: "flex", gap: 10, width: "100%", maxWidth: 360 }}>
              {loading ? (
                <div style={{ ...btnBase, background: "#0ea5e9", color: "#fff", display: "flex", alignItems: "center", gap: 8, flex: 1, justifyContent: "center" }}>
                  <CircularProgress style={{ color: "#fff", width: 14, height: 14 }} />
                  Transferindo...
                </div>
              ) : (
                <button
                  onClick={TransferirChamada}
                  style={{ ...btnBase, background: "#111827", color: "#fff", flex: 1 }}
                  onMouseEnter={e => e.currentTarget.style.background = "#374151"}
                  onMouseLeave={e => e.currentTarget.style.background = "#111827"}
                >
                  Confirmar
                </button>
              )}
              <button
                onClick={EscolherOutro}
                style={{ ...btnBase, background: "#f3f4f6", color: "#374151" }}
              >
                Voltar
              </button>
            </div>
          </div>
          <Divider />
          <button onClick={() => setModalAtendente(false)} style={{ ...btnBase, background: "none", color: "#9ca3af", marginTop: 8 }}>
            Fechar
          </button>
        </>
      )}
    </Modal>
  );
}

export default ModalEncaminhamentoChamada;